<template>
  <div v-if="customer" class="gmf-customer-stats">
    <div class="gmf-customer-stats-stat">
      <Icon class="gmf-customer-stats-icon" icon="stats_achievements" />
      <span class="gmf-customer-stats-number">{{ customer.unlockedAchievementCount }}</span>
    </div>
    <div class="gmf-customer-stats-stat">
      <Icon class="gmf-customer-stats-icon" icon="stats_comments" />
      <span class="gmf-customer-stats-number">{{ customer.commentCount }}</span>
    </div>
    <div class="gmf-customer-stats-stat">
      <Icon class="gmf-customer-stats-icon" icon="stats_likes" />
      <span class="gmf-customer-stats-number">{{ customer.receivedUpvoteCount }}</span>
    </div>
    <template v-if="isMyProfile && showTokenShop && tokenBalances">
      <div class="gmf-customer-stats-stat gmf-clickable" v-for="token in tokenBalances" :key="token.uuid" @click="openTokenShop">
        <span class="gmf-customer-stats-expanded-number gmf-customer-stats-expanded-token"><img :src="token.token.icon" class="gmf-token"/>{{ token.amount }}</span>
      </div>
    </template>
    <div class="gmf-customer-stats-stat gmf-clickable" v-if="tutorialEnabled" @click="openTutorialModal">
      <Icon class="gmf-customer-stats-icon" icon="question"/>
    </div>
  </div>
</template>

<style>
  .gmf-customer-stats {
    display: flex;
    gap: var(--gmf-p-3);
  }
  .gmf-customer-stats-stat {
    display: flex;
    align-items: center;
    gap: var(--gmf-p-2);
    line-height: 0 !important;
  }
  .gmf-customer-stats-icon {
    width: 22px;
    height: 22px;
  }
  .gmf-customer-stats-number {
    font-size: var(--gmf-subheader-font-size);
  }
</style>

<script>
import state from '@/state';
import Icon from '@/components/Icon.vue';
import { getMyTokenBalance } from '@/utils/getMyTokenBalance';
import openTokenShop from './TokenShop/openTokenShop';
import openTutorialModal from '@/widgets/Tutorial/openTutorialModal';

export default {
  components: {
    Icon,
  },
  props: ['customer'],
  data() {
    return {
      tokenBalances: null,
    }
  },
  computed: {
    isMyProfile() {
      return this.customer.id === state.profile?.id;
    },
    tutorialEnabled() {
      return state.merchantConfig.widgets?.tutorial?.enabled;
    },
    showTokenShop() {
      return state.merchantConfig.tokenShop?.enabled;
    },
  },
  methods: {
    openTokenShop,
    openTutorialModal
  },
  async mounted() {
    if (this.isMyProfile) {
      this.tokenBalances = await getMyTokenBalance();
    }
  },
};
</script>
